import styled from 'styled-components';

export const Content = styled.div`
  flex: 1;
  padding: ${({ theme }) => `0 0 ${theme.spacing(10)}`};

  overflow: auto;
`;

export const MetaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};
`;
